import algoliasearch from 'algoliasearch/lite';
import { AisInstantSearch, AisSearchBox, AisHighlight, AisStats, AisConfigure } from 'vue-instantsearch';
import CdnMixin from '@SHARED/js/Vue/mixins/CdnMixin';
import template from './GlobalHeaderSearch.html';

export default {
  template,

  mixins: [CdnMixin],

  components: {
    AisInstantSearch,
    AisSearchBox,
    AisHighlight,
    AisStats,
    AisConfigure,
  },

  data() {
    return {
      searchClient: algoliasearch('QPL7PXFK5U', '019627e6fe46f449cf99b13b2464dd74'),
      index: 'global',
    };
  },
};
